import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const EyeIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <path d="M7 6.5C7.82843 6.5 8.5 5.82843 8.5 5C8.5 4.17157 7.82843 3.5 7 3.5C6.17157 3.5 5.5 4.17157 5.5 5C5.5 5.82843 6.17157 6.5 7 6.5ZM7 7.5C8.38071 7.5 9.5 6.38071 9.5 5C9.5 3.61929 8.38071 2.5 7 2.5C5.61929 2.5 4.5 3.61929 4.5 5C4.5 6.38071 5.61929 7.5 7 7.5Z" />
    <path d="M12.9188 5C12.4544 6.0021 11.5717 6.96447 10.4943 7.70835C9.28949 8.54025 7.9852 9 7 9C6.02338 9 4.59434 8.48469 3.31334 7.61127C2.14088 6.81187 1.32733 5.87459 1.05162 5.0651C1.50752 4.03965 2.40503 3.05163 3.50569 2.29165C4.71051 1.45975 6.0148 1 7 1C7.9852 1 9.28949 1.45975 10.4943 2.29165C11.5717 3.03553 12.4544 3.9979 12.9188 5ZM7 10C9.5 10 13 7.75 14 5C13 2.25 9.5 0 7 0C4.5 0 1 2.25 0 5C0.5 7.5 4.5 10 7 10Z" />
  </BaseIcon>
);
